// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1dXep","header":"PatientQuestionnaire_header__HEqY_","info":"PatientQuestionnaire_info__1Phtu"};